import { render, staticRenderFns } from "./DeviceTable.vue?vue&type=template&id=0fd1afcc&scoped=true"
import script from "./DeviceTable.vue?vue&type=script&lang=js"
export * from "./DeviceTable.vue?vue&type=script&lang=js"
import style0 from "./DeviceTable.vue?vue&type=style&index=0&id=0fd1afcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1afcc",
  null
  
)

export default component.exports